module.exports = __webpack_public_path__ + "static/media/brand-refresh-map-zoom-plus.b2b92339.svg";